var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0 bg-primary-gradient", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        {
          class: { "mb-4": !(_vm.noPadding || _vm.subtitle) },
          attrs: {
            flat: "",
            dense: "",
            extended: "",
            color: "transparent",
            dark: "",
            title: _vm.currentRoute.text,
          },
        },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "home" } } },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { size: "20px", title: "Home" } },
                [_vm._v("home")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-icon", { attrs: { small: "" } }, [_vm._v("chevron_right")]),
          _vm._v(" "),
          _c("v-breadcrumbs", {
            staticClass: "white-breadcrumbs drop-shadow font-weight-light",
            attrs: { dark: "", items: _vm.breadcrumbs, divider: ">" },
            scopedSlots: _vm._u([
              {
                key: "divider",
                fn: function () {
                  return [_c("v-icon", [_vm._v("chevron_right")])]
                },
                proxy: true,
              },
              {
                key: "item",
                fn: function (props) {
                  return [
                    props.item !== _vm.currentRoute
                      ? _c(
                          "v-breadcrumbs-item",
                          { attrs: { exact: "", to: props.item.to } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.item.text) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "v-toolbar-title",
            {
              staticClass: "display-2 pb-2 drop-shadow",
              class: { "loading-dots": _vm.loading },
              staticStyle: { "margin-left": "0px", "padding-bottom": "15px" },
              attrs: { slot: "extension" },
              slot: "extension",
            },
            [
              this.$slots.title
                ? _vm._t("title")
                : [
                    _c(
                      "v-icon",
                      {
                        staticStyle: { "padding-bottom": "10px" },
                        attrs: { large: "" },
                      },
                      [_vm._v(_vm._s(_vm.currentRoute.icon))]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.currentRoute.text) +
                        "\n        "
                    ),
                    _vm.loading
                      ? [
                          _c("span", [_vm._v(".")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(".")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(".")]),
                        ]
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      this.$slots.subtitle
        ? _vm._t("subtitle")
        : _vm.subtitle
        ? _c(
            "v-toolbar",
            {
              class: { "mb-4": !_vm.noPadding },
              attrs: { flat: "", dense: "", color: "transparent", dark: "" },
            },
            [
              _c("span", {
                staticClass:
                  "subheading drop shadow font-weight-regular body-2",
                domProps: { innerHTML: _vm._s(_vm.subtitle) },
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }